import AccountsApiClient from '../clients/accountsApi'
import _get from 'lodash/get'

const Service = {
  async getPasswordSettings() {
    return AccountsApiClient.getPasswordSettings()
        .then(response => response.data);
  }
};
export default Service;
